const NOTIFICATION_TYPE__ALERT__INTERESTING_SITUATION = "interesting_situation";
const NOTIFICATION_TYPE__ALERT__MEDIA_MONITOR = "media_monitor";
const NOTIFICATION_TYPE__ALERT__PRICE_ALERTS = "price_alerts";
const NOTIFICATION_TYPE__ALERT__DEMAND_ZONE = "demand_zone";
const NOTIFICATION_TYPE__ALERT__SQUABER_TEAM_COMMENT = "squaber_team_comment";
const NOTIFICATION_TYPE__ALERT__RECOMMENDATIONS = "stock_messages";

const NOTIFICATION_TYPE__ALERT__DONCHAIN_H1 = "donchain_h1";
const NOTIFICATION_TYPE__ALERT__DONCHAIN_H4 = "donchain_h4";
const NOTIFICATION_TYPE__ALERT__ICHIMOKU_KINKO_HYO_H1 = "ichimoku_h1";
const NOTIFICATION_TYPE__ALERT__ICHIMOKU_KINKO_HYO_H4 = "ichimoku_h4";
const NOTIFICATION_TYPE__ALERT__TRANSACTION_STRATEGY_HIGHS_AND_LOWS =
  "transaction_strategy_highs_and_lows";
const NOTIFICATION_TYPE__ALERT__TRANSACTION_STRATEGY_SUPPLY_DEMAND =
  "transaction_strategy_supply_demand";
const NOTIFICATION_TYPE__ALERT__TRANSACTION_STRATEGY_TREND =
  "transaction_strategy_trend";

const sectionsMap = {
  [NOTIFICATION_TYPE__ALERT__INTERESTING_SITUATION]: "section-current-signal",
  [NOTIFICATION_TYPE__ALERT__MEDIA_MONITOR]: "section-media-monitor",
  [NOTIFICATION_TYPE__ALERT__PRICE_ALERTS]: "section-price-alerts",
  [NOTIFICATION_TYPE__ALERT__DEMAND_ZONE]: "section-chart",
  [NOTIFICATION_TYPE__ALERT__SQUABER_TEAM_COMMENT]: "section-stock-analyses",
  [NOTIFICATION_TYPE__ALERT__RECOMMENDATIONS]: "section-recommendations",
  [NOTIFICATION_TYPE__ALERT__DONCHAIN_H1]: "donchain_h1",
  [NOTIFICATION_TYPE__ALERT__DONCHAIN_H4]: "donchain_h4",
  [NOTIFICATION_TYPE__ALERT__ICHIMOKU_KINKO_HYO_H1]: "ichimoku_h1",
  [NOTIFICATION_TYPE__ALERT__ICHIMOKU_KINKO_HYO_H4]: "ichimoku_h4",
  [NOTIFICATION_TYPE__ALERT__TRANSACTION_STRATEGY_HIGHS_AND_LOWS]:
    "transaction_strategy_highs_and_lows",
  [NOTIFICATION_TYPE__ALERT__TRANSACTION_STRATEGY_SUPPLY_DEMAND]:
    "transaction_strategy_supply_demand",
  [NOTIFICATION_TYPE__ALERT__TRANSACTION_STRATEGY_TREND]:
    "transaction_strategy_trend"
};

export const NOTIFICATION_TYPES = {
  INTERESTING_SITUATION: "interesting_situation",
  MEDIA_MONITOR: "media_monitor",
  PRICE_ALERTS: "price_alerts",
  DEMAND_ZONE: "demand_zone",
  SQUABER_TEAM_COMMENT: "squaber_team_comment",
  RECOMMENDATIONS: "stock_messages",
  DONCHAIN_H1: "donchain_h1",
  DONCHAIN_H4: "donchain_h4",
  ICHIMOKU_KINKO_HYO_H1: "ichimoku_h1",
  ICHIMOKU_KINKO_HYO_H4: "ichimoku_h4",
  TRANSACTION_STRATEGY: "transaction_strategy",
  TRANSACTION_STRATEGY_HIGHS_AND_LOWS: "transaction_strategy_highs_and_lows",
  TRANSACTION_STRATEGY_SUPPLY_DEMAND: "transaction_strategy_supply_demand",
  TRANSACTION_STRATEGY_TREND: "transaction_strategy_trend",
  SUPPLY_DEMAND_SUMMARY: "supply_demand_summary",
  STOCK_ANALYSIS_CATEGORY_TECHNICAL_ANALYSIS:
    "stock_analysis_category_technical_analysis",
  STOCK_ANALYSIS_CATEGORY_VIDEO_ANALYSIS:
    "stock_analysis_category_video_analysis",
  STOCK_ANALYSIS_CATEGORY_MORNING_BRIEF:
    "stock_analysis_category_morning_brief",
  STOCK_ANALYSIS_CATEGORY_FINANCIAL_ANALYSIS:
    "stock_analysis_category_financial_analysis",
  STOCK_ANALYSIS_CATEGORY_SHORT_TECHNICAL_ANALYSIS:
    "stock_analysis_category_short_technical_analysis",
  INSIDER_ANALYSIS_CATEGORY_ANALYSIS: "insider_analysis_category_analysis",
  INSIDER_ANALYSIS_CATEGORY_RECOMMENDATION: "insider_analysis_category_recommendation",
  HIGHS_AND_LOWS_CORRECTION: "highs_and_lows_correction",
  HIGHS_AND_LOWS_SUMMARY: "highs_and_lows_summary",
  THIRD_PARTY_OFFERING: "third_party_offering",
  SPECIAL_OFFER: "special_offer",
  EDUCATION_EVENT: "education_event",
  WEBINAR: "webinar"
};

export default function getStockPageSectionFromNotificationType(
  notificationType
) {
  return sectionsMap[notificationType];
}

export const getNotificationTypeFromStockPageSection = (
  stockPageSection = ""
) => {
  const notificationType = Object.keys(sectionsMap).find(
    key => sectionsMap[key] === stockPageSection
  );

  if (typeof notificationType === "undefined" || notificationType === null) {
    return "";
  }

  return notificationType;
};
